import { useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { BottomNav } from '../components/BottomNav';
import { CalendarDays, Timer, Dumbbell, Flame } from 'lucide-react';

import GroupesPage from './GroupesPage';
import MonProgrammePage from './MonProgrammePage';
import PlanningPage from './PlanningPage';
import ExercisesPage from './ExercisesPage';
import TimerPage from './TimerPage';
import TrainingCaloriesPage from '../components/TrainingCalories';

const TABS = [
  { id: 'semaine', icon: CalendarDays, label: 'Ma Semaine' },
  { id: 'exercices', icon: Dumbbell, label: 'Exercices' },
  { id: 'calories', icon: Flame, label: 'Depense' },
  { id: 'timer', icon: Timer, label: 'Timer' },
];

export default function EntrainementPage() {
  const [searchParams] = useSearchParams();
  const initialTab = searchParams.get('tab') || 'semaine';
  const [activeTab, setActiveTab] = useState(initialTab);

  return (
    <div className="min-h-screen bg-[#0F0F0F] pb-20">
      {/* Tab bar */}
      <div className="sticky top-0 z-40 bg-[#0F0F0F] border-b border-[#2A2A2E]">
        <div className="flex">
          {TABS.map(({ id, icon: Icon, label }) => (
            <button
              key={id}
              onClick={() => setActiveTab(id)}
              data-testid={`tab-${id}`}
              className={`flex-1 flex items-center justify-center gap-1.5 min-h-[48px] px-3 text-xs font-semibold transition-colors border-b-2 ${
                activeTab === id
                  ? 'text-[#FF6B35] border-[#FF6B35]'
                  : 'text-zinc-500 border-transparent active:text-zinc-300'
              }`}
            >
              <Icon className="w-4 h-4" />
              {label}
            </button>
          ))}
        </div>
      </div>

      {/* Ma Semaine = Groupe + Programme + Planning all together */}
      {activeTab === 'semaine' && (
        <div className="space-y-0">
          <GroupesPage embedded />
          <div className="px-4 py-3 bg-[#0F0F0F] border-t border-[#2A2A2E]">
            <p className="text-xs text-[#FF6B35] font-semibold uppercase tracking-widest">Mon Programme</p>
          </div>
          <MonProgrammePage embedded />
          <div className="px-4 py-3 bg-[#0F0F0F] border-t border-[#2A2A2E]">
            <p className="text-xs text-[#FF6B35] font-semibold uppercase tracking-widest">Planning & Presence</p>
          </div>
          <PlanningPage embedded />
        </div>
      )}

      {activeTab === 'exercices' && <ExercisesPage embedded />}
      {activeTab === 'calories' && <TrainingCaloriesPage />}
      {activeTab === 'timer' && <TimerPage embedded />}

      <BottomNav />
    </div>
  );
}
